export enum MediaDatabase {
  INDEX = '/media-database',
}
